<mat-dialog-actions>
  <ion-row class="col-md-reverse w-100">
    <ion-col size="12" size-md class="phi-align-content-center">
      <div class="popup-heading">
        <p class="fs-16 fs_14ForMobile font_regular">Manpower Plan vs Actual</p>
      </div>
    </ion-col>
    <ion-col size="12" size-md="auto" class="phi-align-content-center">
      <div class="popup-close mb-md-15 phi-justify-content-end">
        <button (click)="downloadExcel(getManpowerPlanvsActualData)" class="download-btn">
          <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
          <span *ngIf="!mobileResponsiveService.hideForMobile">Download</span>
        </button>
        <span [mat-dialog-close] class="ml-35 ml-md-10 mr-5 fs-30 fs_24ForMobile material-icons popup-close-icon">close</span>
      </div>
    </ion-col>
  </ion-row>
</mat-dialog-actions>

<mat-dialog-content class="p-15">
  <div class="table-container">
    <table class="Market-correction-employees-table">
      <thead>
        <tr>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">
            <div class="icon-style">Department</div>
          </th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">
            <div class="icon-style">Band</div>
          </th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">
            <div class="icon-style">Plan (Active +vacant) -A</div>
          </th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">
            <div class="icon-style">Actual (active in employee Master)-B</div>
          </th>
          <th class="fs-14 fs_12ForMobile font_bold cl-black">
            <div class="icon-style">Gap (A-B)</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let department of getManpowerPlanvsActualData">
          <ng-container *ngFor="let band of department.bands; let i = index">
            <tr>
              <td *ngIf="i === 0" [attr.rowspan]="department.bands.length">{{department.department}}</td>
              <td >{{band.band}}</td>
              <td>{{band.plan}}</td>
              <td>{{band.actual}}</td>
              <td>{{band.gap}}</td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</mat-dialog-content>